import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import moment from "moment";

export default createStore({
  plugins: [
    createPersistedState({ storage: window.sessionStorage })
  ],
  state: {
    menuName: '',
    userCode: '',
    userName: '',
    roleCode: '',
    userInfo: {},
    permissions: [],
    locale: '',
    isAutherized: false,
    accessTokenKey: '',
    refreshToken: '',
    tokenExpire: null
  },
  getters: {
    
  },
  mutations: {
    MENU_NAME(state, payload) {
      state.menuName = payload
    },
    SET_USER_LOGIN(state, payload) {
      const userName = payload.userName + ' ' + payload.userLastname
      state.userCode = payload.userCode
      state.userName = userName
      state.roleCode = payload.roleCode
    },
    SET_USER_INFO(state, payload) {
      state.userInfo = payload
    },
    SET_CURRENT_LOCALE(state, payload) {
      state.locale = payload
    },
    SET_PERMISSIONS(state, payload) {
      state.permissions = payload
    },
    SET_AUTHERIZED(state, payload) {
      state.isAutherized = payload
    },
    ACCESS_TOKEN_KEY(state, payload) {
      state.accessTokenKey = payload
    },
    REFRESH_TOKEN_KEY(state, payload) {
      state.refreshToken = payload
    },
    TOKEN_EXPIRE(state, payload) {
      state.tokenExpire = payload
    },
    LOG_OUT(state) {
      state.menuName = ''
      state.userCode = 'SYSTEM'
      state.userName = ''
      state.userInfo = {}
      state.permissions = []
      state.locale = ''
      state.isAutherized = false
      state.accessTokenKey = ''
      state.refreshToken = ''
      state.tokenExpire = null
    }
  },
  actions: {
    setMenuName(context, payload) {
      context.commit('MENU_NAME', payload)
    },
    setUserLogin(context, payload) {
      context.commit('SET_USER_LOGIN', payload)
    },
    setUserInfo(context, payload) {
      context.commit('SET_USER_INFO', payload)
    },
    setCurrentLocale(context, payload) {
      context.commit('SET_CURRENT_LOCALE', payload)
    },
    setPermission(context, payload:any[]) {
      context.commit('SET_PERMISSIONS', payload)
    },
    setIsAutherized(context, payload) {
      context.commit('SET_AUTHERIZED', payload)
    },
    setTokenKey(context, payload) {
      context.commit('ACCESS_TOKEN_KEY', payload.accessToken)
      context.commit('REFRESH_TOKEN_KEY', payload.refreshToken)
      context.commit('TOKEN_EXPIRE', moment().add(payload.expires, 'seconds'))
    },
    setAccessTokenKey(context, payload) {
      context.commit('ACCESS_TOKEN_KEY', payload)
    },
    setRefreshTokenKey(context, payload) {
      context.commit('REFRESH_TOKEN_KEY', payload)
    },
    setLogout(context) {
      context.commit('LOG_OUT')
    }
  },
  modules: {},
});
